import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import './mycss.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Apiconnect from "../services/Apiconnect.js";


const Forgetpassword = () => {

   const { login } = useContext(AuthContext);
   const [bgimg, setBgimg] = useState('');
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const [passwordVisible, setPasswordVisible] = useState(false);
   const [isLoading, setIsLoading] = useState(false);



   const navigate = useNavigate();


   useEffect(() => {
      const randomImageUrl = getRandomImage();
      setBgimg(randomImageUrl);
   }, [setBgimg]);


   const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      var indata = {
         "email": email,
      };

      console.warn(indata);

      try {
         await Apiconnect.postDataNoauth("auth/forgetpass", indata).then((response) => {
            console.log(response.data);
            if (response.data.status === 1) {
               toast.success('Email Sent Successfully');
               localStorage.setItem("reset_email", email);
               setTimeout(() => {
                  navigate("/resetpass", { replace: true });
               }, 2000);
            } else {
               toast.error(response.data.message);
            }
            setIsLoading(false);

         });
      } catch (error) {
         var err = 'Somthing went wrong!!';
         if (error.response) {
            console.log('Response error:', error.response.data);
            console.log('Response status:', error.response.status);
            console.log('Response headers:', error.response.headers);
         } else if (error.request) {
            console.log('Request error:', error.request);
         } else {
            console.log('General error:', error.message);
         }

         toast.error(err);
      }




   };
   const getRandomImage = () => {
      const randomNum = Math.floor(Math.random() * 9) + 1; // Generates a number between 1 and 9
      return `admin_codebase/bgpic1.jpg`;
   };





   return (
      <>



         <div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
               <div class="col-xl-7 example"
                  style={{

                     backgroundImage: `url(${bgimg})`,


                  }}

               >

               </div>

               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                     <div class="w-100 p-5" >

                        <div class="text-center">

                           <img style={{ maxWidth: '50%', marginBottom: 30, }} src="admin_codebase/b-logo.png" />


                           <h2><b>Forgot Password?</b></h2>



                        </div>


                        <form onSubmit={handleSubmit} >
                           <div class="row">

                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">Email Address *</label>
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} class="form-control inp" placeholder="Enter Your Email" required />
                                 </div>
                              </div>
                           </div>





                           <div class="form-outline mb-4">
                              <label class="form-label" for="form1Example23"></label>
                              <input
                                 type="submit"
                                 id=""
                                 class="form-control form-control-lg btn btn-primary submit"
                                 value={isLoading ? "Please wait..." : "Send Reset Link"}
                                 disabled={isLoading}
                              />
                           </div>
                        </form>

                        Back to <a href="/">Login</a>











                     </div>
                  </div>
               </div>
            </div>
            <ToastContainer />
         </div>

      </>
   );
};

export default Forgetpassword;
